import { render, staticRenderFns } from "./email-dialog.vue?vue&type=template&id=08fc8531&scoped=true&"
import script from "./email-dialog.vue?vue&type=script&lang=js&"
export * from "./email-dialog.vue?vue&type=script&lang=js&"
import style0 from "./email-dialog.vue?vue&type=style&index=0&id=08fc8531&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fc8531",
  null
  
)

export default component.exports